module.exports = __webpack_public_path__ + "static/media/lincoln-vial.741c4ca1.svg";